import { useContext, useEffect, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import AlertDialog from "../AlertDialog/AlertDialog";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useNavigate } from "react-router-dom";
import ProcessViewDialogBox from "../ProcessView/ProcessViewDialogBox";
import { ProcessEnum, ProcessEnumDisplayLabel } from "../../Types/Enum";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { Button, Chip, CircularProgress, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from "@mui/material";
import { DeleteRounded, EditRounded, OpenInNew } from "@mui/icons-material";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";
import { parseISO, format } from "date-fns";

const ProcessTable = (props: { filter: any }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [process, setProcess] = useState(null);
  const [processList, setProcessList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);
  const [value, setValue] = useState({});
  const [limit, setLimit] = useState(50);
  const { changeLoading, isLoading } = useContext(LoadingStateContext);

  useEffect(() => {
    getProcessList();
  }, [page, props.filter, value, limit]);

  const getProcessList = async () => {
    changeLoading(true);
    try {

      const response = await axiosInstance.get(
        `/v1/process?type_dom_corp=${theme.theme}&page=${page}&items_per_page=${limit}`,
        {
          params: props.filter,
        }
      );

      const data = response.data;
      setProcessList(data.result.data);

      setTotalItems(data.result.total);

    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  const getProcessById = async (processId: number, action: EDialogAction) => {
    try {
      const response = await axiosInstance.get(`/v1/process/${processId}`, {});

      const data = response.data;

      setProcess(data.result.process);

      if (action == EDialogAction.edit) {

        setEditDialogVisibility(true);


      } else if (action == EDialogAction.view) {

        setEditDialogVisibility(true);
      } else if (action == EDialogAction.delete) {
        setAlertDialogVisibility(true);
      }
      setDialogAction(action);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const deleteProcess = async (ProcessId: number) => {
  //   try {
  //     const response = await axiosInstance.delete(`/v1/process/${ProcessId}`);

  //     console.log("deleted Process");
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const goToNextPage = () => {

    setPage(page + 1);

  };

  const goToPreviousPage = () => {
    setPage(page - 1);
  };
  const refresh = () => {
    setValue({});
  };
  function editDialogClose(action: EDialogAction) {
    setEditDialogVisibility(false);
    if (action == EDialogAction.edit) {
      refresh();
    } else if (action == EDialogAction.view) {
    } else if (action == EDialogAction.delete) {
    }
    getProcessList();
  }
  function alertDialogClose(action: EDialogAction) {
    setAlertDialogVisibility(false);
    getProcessList();
  }

  const pageChangeHandler = (processId: any) => {
    navigate({
      pathname: "/admin/process-view",
      search: `?processId=${processId}`,
    });
  };

  return (
    <>
      <ProcessViewDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={process}
        dialogAction={dialogAction}
      />
      <AlertDialog
        openAlert={alertDialogVisibility}
        onCloseAlert={alertDialogClose}
        data={process}
        action="process"
      />
      <Paper>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Passport Id - Name</TableCell>
                <TableCell>Reference Code</TableCell>
                <TableCell>Country Code</TableCell>
                <TableCell>Job Title</TableCell>
                <TableCell>Status</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isLoading && processList.map((data: any, key: number) => {
                return (
                  <TableRow key={data.id}>
                    <TableCell>{data.id}</TableCell>
                    <TableCell>{format(parseISO(data.created_at), "yyyy-MM-dd")}</TableCell>
                    <TableCell>{data.resume.passport_no} - {data.resume.first_name} {data.resume.last_name}</TableCell>
                    <TableCell>
                      {data.resume && data.resume.customer_reference
                        ? `${data.resume.customer_reference}`
                        : 'N/A'}
                    </TableCell>
                    <TableCell>{data.country_process.country_code}</TableCell>
                    <TableCell>{data.country_process.title}</TableCell>
                    <TableCell align="center">
                      <Chip
                        className="text-[10px] font-[bold]"
                        size="small"
                        label={ProcessEnumDisplayLabel[data.status]}
                        color={
                          data.status == ProcessEnum.started ||
                            data.status == ProcessEnum.processing ||
                            data.status == ProcessEnum.completed
                            ? "success"
                            : "error"
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          pageChangeHandler(data.id);
                        }}
                      >
                        <OpenInNew />
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          getProcessById(data.id, EDialogAction.edit);
                        }}
                      >
                        <EditRounded />
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          getProcessById(data.id, EDialogAction.delete);
                        }}
                      >
                        <DeleteRounded />
                      </Button>
                    </TableCell>

                  </TableRow>
                );
              })}
              {!isLoading && processList.length == 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              count={totalItems}
              rowsPerPage={limit}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Table>
        </TableContainer>

      </Paper>
    </>
  );
}
export default ProcessTable;
